import { renderEditField } from "../../helper/functions";

export default function EditField({ field, data = {}, customOnChange }) {
  return <div className="w-full">{renderEditField(field, data, customOnChange)}</div>;
}
